import classnames from "classnames";
import React, { Dispatch, SetStateAction } from "react";

import { useGranite } from "@redux/modules/value/translations/translations.provider";

import { Button } from "@components/General/Button/button.component";

type OpenFiltersButtonProps = {
    setOpen: Dispatch<SetStateAction<boolean>>;
    className?: string;
};

const OpenFiltersButton = ({ setOpen, className }: OpenFiltersButtonProps) => {
    const { t } = useGranite();

    const handleOnFilterButtonClick = () => setOpen(() => true);

    return (
        <Button
            type={"button"}
            className={classnames(
                "text-left cursor-pointer mr-sm-3 mr-md-0",
                className,
            )}
            color={"gray"}
            onClick={handleOnFilterButtonClick}
        >
            <i className={"las la-filter mr-2"} />
            {t("search.refinements.showFiltersButton")}
        </Button>
    );
};

export { OpenFiltersButton };
